import { render, staticRenderFns } from "./EmployeeActiveStatus.vue?vue&type=template&id=3a58b447&scoped=true&"
import script from "./EmployeeActiveStatus.vue?vue&type=script&lang=js&"
export * from "./EmployeeActiveStatus.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeActiveStatus.vue?vue&type=style&index=0&id=3a58b447&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a58b447",
  null
  
)

export default component.exports